export const fiscalLawOptionsNue = [
  { id: 'MICRO_FONCIER', value: 'Micro-foncier' },
  { id: 'FONCIER', value: 'Foncier réel' },
];

export const fiscalLawOptionsMeublee = [
  { id: 'MICRO_BIC', value: 'Micro-BIC longue durée' },
  {
    id: 'MICRO_BIC_TOURISME_CLASSE',
    value: 'Micro-BIC meublé de tourisme classé',
  },
  {
    id: 'MICRO_BIC_TOURISME_NON_CLASSE',
    value: 'Micro-BIC meublé de tourisme non classé',
  },
  { id: 'BIC', value: 'BIC réel' },
];
